/* Igor & James · global UI behaviours (Shopify OS 2.0 theme)
   Ported 1:1 from the approved prototype site.js, extended with the real store wiring:
   - Cart drawer: real /cart/add.js + /cart/change.js AJAX, re-rendered via the Section Rendering API
   - PDP: real variant selection (size pills), price/ATC/sticky sync
   - Card quick-add: real variant add-to-cart from the size pills on hover
   Everything visual (reveal, marquee pauses, toggles, filters, wishlist) is the prototype's own logic. */
(function () {
  "use strict";

  var IJ = window.IJ || { strings: {}, routes: {} };

  // --- money formatting (cents -> "€ 12,34" via shop money format) --------
  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var amount = whole + "," + parts[1];
    var fmt = IJ.moneyFormat || "€{{amount}}";
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/<[^>]+>/g, "");
  }

  // --- back-to-top --------------------------------------------------------
  var toTop = document.getElementById("toTop");
  if (toTop) {
    var onScroll = function () {
      if (window.pageYOffset > 400) toTop.classList.add("ij-is-visible");
      else toTop.classList.remove("ij-is-visible");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    toTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // --- transparent header over hero: go solid past the hero (home only) ---
  (function () {
    var header = document.querySelector(".header");
    if (!header || !document.body.classList.contains("is-home")) return;
    var hero = document.querySelector(".hero");
    // pull the hero up under the header by EXACTLY the header height (no white seam)
    function syncHero() {
      if (hero) hero.style.marginTop = "-" + header.offsetHeight + "px";
    }
    function onHdr() {
      var t = hero ? hero.offsetHeight - 120 : 200;
      header.classList.toggle("is-solid", window.pageYOffset > t);
    }
    syncHero();
    onHdr();
    window.addEventListener("load", syncHero);
    window.addEventListener("scroll", onHdr, { passive: true });
    window.addEventListener("resize", function () { syncHero(); onHdr(); }, { passive: true });
  })();

  // --- announcement bar rotation ------------------------------------------
  (function () {
    var bar = document.querySelector("[data-annc]");
    if (!bar) return;
    var el = bar.querySelector(".annc__msg");
    var msgs;
    try { msgs = JSON.parse(bar.getAttribute("data-annc")); } catch (e) { msgs = []; }
    if (!el || msgs.length < 2) return;
    var i = 0, paused = false;
    bar.addEventListener("mouseenter", function () { paused = true; });
    bar.addEventListener("mouseleave", function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      el.classList.add("is-fading");
      setTimeout(function () {
        i = (i + 1) % msgs.length;
        el.textContent = msgs[i];
        el.classList.remove("is-fading");
      }, 300);
    }, 3500);
  })();

  // --- mobile menu ---------------------------------------------------------
  (function () {
    var menu = document.getElementById("mobile-menu");
    var backdrop = document.querySelector("[data-menu-backdrop]");
    if (!menu || !backdrop) return;
    function close() { menu.classList.remove("ij-is-open"); backdrop.classList.remove("ij-is-open"); }
    function open() { menu.classList.add("ij-is-open"); backdrop.classList.add("ij-is-open"); }
    document.querySelectorAll("[data-menu-toggle]").forEach(function (t) {
      t.addEventListener("click", function () {
        menu.classList.contains("ij-is-open") ? close() : open();
      });
    });
    backdrop.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  })();

  // --- Card colour swatches (Igor 2026-09-15) ------------------------------
  // The swatches are SPANS inside the card's own <a>: nested anchors would be
  // invalid HTML, and keeping them uncrawlable avoids handing link equity to every
  // colourway, which is the cannibalisation problem that got swatches skipped once.
  // So navigation is done here. stopPropagation matters - without it the click
  // bubbles to the card anchor and you land on the product you were already on.
  document.addEventListener("click", function (e) {
    var sw = e.target.closest && e.target.closest(".pcard__swatch");
    if (!sw) return;
    var url = sw.getAttribute("data-swatch-url");
    if (!url) return;                       // the "+N" chip has no url, let it do nothing
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  });

  // --- Dames/Heren toggle sections (full ARIA tabs pattern) ---------------
  document.querySelectorAll("[data-toggle-section]").forEach(function (sec) {
    var tablist = sec.querySelector('[role="tablist"]');
    var btns = Array.prototype.slice.call(sec.querySelectorAll(".favtoggle__btn"));
    var grids = sec.querySelectorAll(".favgrid");

    function activate(btn, moveFocus) {
      var key = btn.getAttribute("data-fav");
      btns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("ij-is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
        b.setAttribute("tabindex", on ? "0" : "-1");
      });
      grids.forEach(function (g) {
        g.classList.toggle("ij-is-active", g.getAttribute("data-favgrid") === key);
      });
      if (moveFocus) btn.focus();
    }

    btns.forEach(function (btn) {
      btn.addEventListener("click", function () { activate(btn, false); });
    });

    // Arrow-key navigation between tabs (WAI-ARIA tabs pattern: automatic
    // activation on arrow move, Home/End jump to first/last). Only reachable
    // when the tablist itself is visible/focusable - on the mobile guides
    // layout the tablist is display:none, so this listener simply never fires.
    if (tablist && btns.length > 1) {
      tablist.addEventListener("keydown", function (e) {
        var i = btns.indexOf(document.activeElement);
        if (i === -1) return;
        var next = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = btns[(i + 1) % btns.length];
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = btns[(i - 1 + btns.length) % btns.length];
        else if (e.key === "Home") next = btns[0];
        else if (e.key === "End") next = btns[btns.length - 1];
        if (next) {
          e.preventDefault();
          activate(next, true);
        }
      });
    }
  });

  // --- Wishlist (heart favorites, localStorage) ---------------------------
  var WK = "ij_wishlist";
  function getWish() { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} }
  function updWishCount() {
    var n = getWish().length;
    document.querySelectorAll(".wish-count").forEach(function (el) { el.textContent = n ? n : ""; });
  }
  function bindWishButtons(root) {
    var saved = getWish();
    (root || document).querySelectorAll(".pcard__wish").forEach(function (btn) {
      if (btn._wishBound) return;
      btn._wishBound = true;
      var h = btn.getAttribute("data-wish");
      if (saved.indexOf(h) > -1) btn.classList.add("is-saved");
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var arr = getWish(), i = arr.indexOf(h);
        if (i > -1) { arr.splice(i, 1); btn.classList.remove("is-saved"); }
        else { arr.push(h); btn.classList.add("is-saved"); }
        setWish(arr); updWishCount();
      });
    });
  }
  bindWishButtons();
  updWishCount();
  // Cards that arrive after load (the sorted rails on the collection pages fetch
  // theirs) announce themselves; the binder is idempotent per button.
  document.addEventListener("ij:cards:added", function (e) {
    bindWishButtons(e.detail && e.detail.root);
  });

  // --- SEO copy read-more --------------------------------------------------
  document.querySelectorAll("[data-readmore]").forEach(function (box) {
    var btn = box.querySelector(".col-seo__toggle");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var open = box.classList.toggle("ij-is-open");
      btn.textContent = open ? (IJ.strings.readLess || "Lees minder") : (IJ.strings.readMore || "Lees meer");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  // --- CART: drawer + AJAX -------------------------------------------------
  var cartDrawerEl = document.getElementById("cart-drawer-root");
  function cartOpen() {
    var drawer = document.getElementById("cart-drawer");
    var backdrop = document.querySelector("[data-cart-backdrop]");
    if (drawer) drawer.classList.add("ij-is-open");
    if (backdrop) backdrop.classList.add("ij-is-open");
  }
  function cartClose() {
    var drawer = document.getElementById("cart-drawer");
    var backdrop = document.querySelector("[data-cart-backdrop]");
    if (drawer) drawer.classList.remove("ij-is-open");
    if (backdrop) backdrop.classList.remove("ij-is-open");
  }
  function bindCartDrawer() {
    var backdrop = document.querySelector("[data-cart-backdrop]");
    if (backdrop && !backdrop._bound) {
      backdrop._bound = true;
      backdrop.addEventListener("click", cartClose);
    }
  }
  // one delegated listener: toggles, close buttons, qty +/-, remove
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-cart-toggle]");
    if (toggle) {
      var drawer = document.getElementById("cart-drawer");
      if (drawer && drawer.classList.contains("ij-is-open")) cartClose(); else cartOpen();
      return;
    }
    var qtyBtn = e.target.closest("[data-cart-qty]");
    if (qtyBtn) {
      var key = qtyBtn.getAttribute("data-key");
      var qty = parseInt(qtyBtn.getAttribute("data-qty"), 10);
      changeCart(key, qty);
      return;
    }
    var rm = e.target.closest("[data-cart-remove]");
    if (rm) {
      changeCart(rm.getAttribute("data-key"), 0);
      return;
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") cartClose(); });
  bindCartDrawer();

  function refreshCartDrawer(openAfter) {
    return fetch((IJ.routes.root_url || "/") + "?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html || !cartDrawerEl) return;
        var wasOpen = false;
        var existing = document.getElementById("cart-drawer");
        if (existing) wasOpen = existing.classList.contains("ij-is-open");
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("#cart-drawer-root") || tmp;
        cartDrawerEl.innerHTML = fresh.innerHTML;
        bindCartDrawer();
        if (openAfter || wasOpen) cartOpen();
        var countEl = tmp.querySelector("[data-cart-count-src]");
        if (countEl) {
          var n = countEl.getAttribute("data-cart-count-src");
          document.querySelectorAll(".cart-count").forEach(function (el) {
            el.textContent = n === "0" ? "" : n;
          });
        }
      });
  }

  function addToCart(variantId, quantity) {
    return fetch(IJ.routes.cart_add_url || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return refreshCartDrawer(true);
    });
  }

  function changeCart(key, quantity) {
    return fetch(IJ.routes.cart_change_url || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function () {
      return refreshCartDrawer(false);
    });
  }

  // --- card quick-add (2026-09-23, Igor: Gymshark's pattern) -------------------
  // Desktop: the size bar on the image (CSS hover). Touch: the bag button opens a bottom
  // sheet with the same sizes. A size (or the one-size button) adds straight to the cart
  // through BROADCAST's own add flow (theme:cart:add on a real form), so its drawer opens,
  // re-renders and shows errors itself. The old ij addToCart() targets #cart-drawer-root,
  // which does not exist on this theme: that is why the 09-20 "+" pills never opened a cart.
  function ijqaForm() {
    var f = document.getElementById("ij-qa-form");
    if (f) return f;
    f = document.createElement("form");
    f.id = "ij-qa-form"; f.method = "post"; f.hidden = true;
    f.action = (window.theme && theme.routes && theme.routes.cart_add_url) || "/cart/add";
    f.innerHTML = '<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1"><button type="submit" data-add-to-cart></button>';
    document.body.appendChild(f);
    return f;
  }
  function ijqaAdd(variantId, trigger) {
    var f = ijqaForm();
    f.querySelector('[name="id"]').value = variantId;
    if (trigger) { trigger.classList.add("is-adding"); setTimeout(function () { trigger.classList.remove("is-adding"); }, 1600); }
    if (document.querySelector("cart-drawer") && window.theme && theme.settings && theme.settings.cartType === "drawer") {
      document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: f.querySelector("button") }, bubbles: true }));
    } else {
      f.submit();
    }
  }
  var ijqaSheet = null;
  function ijqaCloseSheet() {
    if (!ijqaSheet) return;
    ijqaSheet.classList.remove("is-open");
    document.documentElement.classList.remove("ijqa-lock");
  }
  function ijqaOpenSheet(qa) {
    if (!ijqaSheet) {
      ijqaSheet = document.createElement("div");
      ijqaSheet.className = "ijqa-sheet";
      ijqaSheet.innerHTML = '<div class="ijqa-sheet__backdrop" data-ijqa-close></div><div class="ijqa-sheet__panel" role="dialog" aria-modal="true"><div class="ijqa-sheet__head"><p class="ijqa-sheet__title"></p><button type="button" class="ijqa-sheet__x" data-ijqa-close aria-label="Close">&times;</button></div><p class="ijqa-sheet__label"></p><div class="ijqa-sheet__body"></div></div>';
      document.body.appendChild(ijqaSheet);
    }
    ijqaSheet.querySelector(".ijqa-sheet__title").textContent = qa.getAttribute("data-product-title") || "";
    var label = qa.querySelector(".ijqa__label");
    ijqaSheet.querySelector(".ijqa-sheet__label").textContent = label ? label.textContent : "";
    var body = ijqaSheet.querySelector(".ijqa-sheet__body");
    body.innerHTML = "";
    var src = qa.querySelector(".ijqa__sizes") || qa.querySelector(".ijqa__btn");
    if (src) body.appendChild(src.cloneNode(true));
    ijqaSheet.classList.add("is-open");
    document.documentElement.classList.add("ijqa-lock");
  }
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest("[data-ijqa-close]")) { e.preventDefault(); ijqaCloseSheet(); return; }
    var open = t.closest("[data-ijqa-open]");
    if (open) { e.preventDefault(); e.stopPropagation(); ijqaOpenSheet(open.closest("[data-ijqa]")); return; }
    var pick = t.closest("[data-ijqa-variant]");
    if (pick) {
      e.preventDefault(); e.stopPropagation();
      if (pick.disabled) return;
      ijqaAdd(pick.getAttribute("data-ijqa-variant"), pick);
      ijqaCloseSheet();
      return;
    }
    // the bar itself is not a link to the PDP: clicks on its gaps must not navigate
    if (t.closest(".ijqa__bar") && !t.closest("a.ijqa__btn")) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") ijqaCloseSheet(); });

  // --- PDP: variant selection + AJAX ATC + sticky sync ---------------------
  var buybox = document.querySelector("[data-buybox]");
  if (buybox) {
    var variants;
    try { variants = JSON.parse(document.querySelector("[data-product-variants]").textContent); } catch (e) { variants = []; }
    var currentId = buybox.getAttribute("data-selected-variant");
    var atcBtn = document.querySelector("[data-atc]");
    var stickyBtn = document.querySelector("[data-sticky-add]");
    var priceEls = { now: document.querySelectorAll("[data-price-now]"), was: document.querySelectorAll("[data-price-was]") };

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(currentId)) return variants[i];
      return null;
    }
    function syncVariantUI() {
      var v = currentVariant();
      if (!v) return;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      priceEls.now.forEach(function (el) {
        el.textContent = formatMoney(v.price);
        el.classList.toggle("now", !!onSale);
      });
      priceEls.was.forEach(function (el) {
        if (onSale) { el.textContent = formatMoney(v.compare_at_price); el.hidden = false; }
        else { el.hidden = true; }
      });
      var soldOut = !v.available;
      [atcBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = soldOut;
        b.textContent = soldOut ? b.getAttribute("data-label-oos") : b.getAttribute("data-label-atc");
      });
    }
    buybox.querySelectorAll(".size[data-variant-id]").forEach(function (pill) {
      pill.addEventListener("click", function () {
        buybox.querySelectorAll(".size").forEach(function (p) { p.classList.remove("size--active"); });
        pill.classList.add("size--active");
        currentId = pill.getAttribute("data-variant-id");
        syncVariantUI();
      });
    });
    function doAdd(btn) {
      if (!currentId || !btn || btn.disabled) return;
      var orig = btn.getAttribute("data-label-atc");
      btn.textContent = IJ.strings.adding || "Toevoegen...";
      addToCart(currentId, 1).then(function () {
        btn.textContent = IJ.strings.added || "Toegevoegd";
        setTimeout(function () { btn.textContent = orig; }, 1600);
      }).catch(function () { btn.textContent = orig; });
    }
    if (atcBtn) atcBtn.addEventListener("click", function (e) { e.preventDefault(); doAdd(atcBtn); });
    if (stickyBtn) stickyBtn.addEventListener("click", function (e) { e.preventDefault(); doAdd(stickyBtn); });
    syncVariantUI();
  }

  // --- size-guide modal ----------------------------------------------------
  (function () {
    var modal = document.getElementById("sizeguide-modal");
    var backdrop = document.querySelector("[data-sizeguide-backdrop]");
    if (!modal || !backdrop) return;
    function close() { modal.classList.remove("ij-is-open"); backdrop.classList.remove("ij-is-open"); }
    function open() { modal.classList.add("ij-is-open"); backdrop.classList.add("ij-is-open"); }
    document.querySelectorAll("[data-sizeguide-toggle]").forEach(function (t) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        modal.classList.contains("ij-is-open") ? close() : open();
      });
    });
    backdrop.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  })();

  // --- PDP gallery (b17) · thumb rail swaps the main stage -----------------
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var stage = gallery.querySelector("[data-stage]");
    gallery.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (stage) stage.src = thumb.getAttribute("data-thumb");
        gallery.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("ij-is-active"); });
        thumb.classList.add("ij-is-active");
      });
    });
    // zoom lives on the stage
    var lb = document.getElementById("pdp-lightbox");
    if (stage && lb) {
      var lbImg = document.getElementById("pdp-lightbox-img");
      stage.addEventListener("click", function () {
        if (lbImg) lbImg.src = stage.getAttribute("data-zoom") || stage.src;
        lb.classList.add("ij-is-open");
      });
      lb.addEventListener("click", function () { lb.classList.remove("ij-is-open"); });
    }
  }

  // --- sticky ATC bar (b19) ------------------------------------------------
  (function () {
    var bar = document.getElementById("sticky-atc");
    var anchor = document.getElementById("pdp-buybox-anchor");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle("ij-is-visible", !e.isIntersecting); });
    }, { threshold: 0 });
    obs.observe(anchor);
  })();

  // --- PLP filter + sort + load-more (b15/b16) -----------------------------
  // One controller owns filtering, sorting and load-more (they fight each other otherwise).
  // Facets are backed by real catalog data rendered onto each card (price / available / sale).
  // The facet panel sits behind the FILTER ICON (content rule 10) · one consistent spot.
  var plpGrid = document.querySelector("[data-plp-grid]");
  if (plpGrid) {
    var PAGE = 12;
    var cards = Array.prototype.slice.call(plpGrid.querySelectorAll(".pcard"));
    var bar = document.querySelector("[data-plp]");
    var panel = document.querySelector("[data-plp-panel]");
    var filterToggle = document.querySelector("[data-plp-filter-toggle]");
    var countEl = document.querySelector("[data-plp-count]");
    var sortEl = document.querySelector("[data-plp-sort]");
    var moreWrap = document.querySelector("[data-plp-more]");
    var moreBtn = moreWrap && moreWrap.querySelector(".loadmore__btn");
    var emptyEl = document.querySelector("[data-plp-empty]");
    var stockEl = panel && panel.querySelector('[data-filter="stock"]');
    var panelClear = panel && panel.querySelector("[data-plp-clear]");
    var shown = PAGE;
    var state = { price: null, sale: false, stock: false, sort: "featured" };

    if (filterToggle && panel) {
      filterToggle.addEventListener("click", function () {
        var open = panel.classList.toggle("ij-is-open");
        filterToggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    cards.forEach(function (c) {
      c._price = parseFloat(c.getAttribute("data-price")) || 0;
      c._avail = c.getAttribute("data-available") === "1";
      c._sale = c.getAttribute("data-sale") === "1";
      c._seq = parseInt(c.getAttribute("data-seq"), 10) || 0;
    });

    var matches = function (c) {
      if (state.stock && !c._avail) return false;
      if (state.sale && !c._sale) return false;
      if (state.price) {
        var b = state.price.split("-");
        if (c._price < parseFloat(b[0]) || c._price >= parseFloat(b[1])) return false;
      }
      return true;
    };

    var render = function () {
      var hits = cards.filter(matches);
      if (state.sort === "price-asc") hits.sort(function (a, b) { return a._price - b._price; });
      else if (state.sort === "price-desc") hits.sort(function (a, b) { return b._price - a._price; });
      // "Nieuwste": collection order reversed (the honest proxy; real created_at sort can
      // come from Shopify's native sort_by when the store enables it)
      else if (state.sort === "new") hits.sort(function (a, b) { return b._seq - a._seq; });
      else hits.sort(function (a, b) { return a._seq - b._seq; });

      cards.forEach(function (c) { c.classList.add("pcard--hidden"); });
      hits.slice(0, shown).forEach(function (c, i) {
        c.classList.remove("pcard--hidden");
        c.style.order = i;
      });

      if (countEl) {
        var tpl = hits.length === 1 ? (IJ.strings.itemsOne || "COUNT artikel") : (IJ.strings.itemsOther || "COUNT artikelen");
        countEl.textContent = tpl.replace("{{ count }}", hits.length).replace("COUNT", hits.length);
      }
      if (emptyEl) emptyEl.hidden = hits.length !== 0;

      var rest = hits.length - shown;
      if (moreWrap) {
        moreWrap.hidden = rest <= 0;
        if (moreBtn && rest > 0) moreBtn.textContent = (IJ.strings.loadMoreCount || "Meer laden (COUNT)").replace("COUNT", rest);
      }
      var anyActive = !!(state.price || state.sale || state.stock);
      if (panelClear) panelClear.hidden = !anyActive;
      if (filterToggle) filterToggle.classList.toggle("has-active", anyActive);
    };

    if (panel) {
      panel.querySelectorAll(".chip[data-filter]").forEach(function (chip) {
        chip.addEventListener("click", function () {
          var key = chip.getAttribute("data-filter");
          var val = chip.getAttribute("data-value");
          var on = chip.classList.contains("chip--active");
          // price chips are single-select; sale is a plain toggle
          if (key === "price") {
            panel.querySelectorAll('.chip[data-filter="price"]').forEach(function (o) { o.classList.remove("chip--active"); });
            state.price = on ? null : val;
          } else {
            state.sale = !on;
          }
          if (!on) chip.classList.add("chip--active");
          else chip.classList.remove("chip--active");
          shown = PAGE;
          render();
        });
      });
    }
    if (stockEl) {
      stockEl.addEventListener("change", function () { state.stock = stockEl.checked; shown = PAGE; render(); });
    }
    if (sortEl) {
      sortEl.addEventListener("change", function () { state.sort = sortEl.value; shown = PAGE; render(); });
    }
    if (moreBtn) {
      moreBtn.addEventListener("click", function () { shown += PAGE; render(); });
    }
    document.querySelectorAll("[data-plp-clear]").forEach(function (el) {
      el.addEventListener("click", function () {
        state.price = null; state.sale = false; state.stock = false;
        if (stockEl) stockEl.checked = false;
        if (panel) panel.querySelectorAll(".chip[data-filter]").forEach(function (o) { o.classList.remove("chip--active"); });
        shown = PAGE;
        render();
      });
    });

    render();
  }

  // --- scroll-reveal -------------------------------------------------------
  // Content sections only · never the hero or the utility bars (.usp/.annc).
  (function () {
    var targets = document.querySelectorAll(
      "main .shopify-section > section.ij:not(.hero):not(.usp)"
    );
    if (!targets.length) return;

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) return;

    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("reveal-in");
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });

    targets.forEach(function (el) {
      // anything already on the first screen shows immediately (no hidden state)
      if (el.getBoundingClientRect().top < vh * 1.05) return;
      el.classList.add("reveal-init");
      io.observe(el);
    });

    // safety net · if IO somehow never fires, reveal everything after 2.5s
    setTimeout(function () {
      document.querySelectorAll(".reveal-init:not(.reveal-in)").forEach(function (el) {
        el.classList.add("reveal-in");
      });
    }, 2500);
  })();
})();


/* Task 29 · tap the PDP USP marquee to pause it (WCAG 2.2.2). Delegated so it survives the
   vendor section re-render on variant change. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest('.block__icon__row');
    if (!row) return;
    row.classList.toggle('ij-usp-paused');
  }, { passive: true });
})();


/* Task 40 · one-time swipe-hint on first view of a swipe row: a native smooth-scroll peek.
   A transform-based nudge was tried first and REJECTED by the gate: the first card rests
   flush against the scroller's clip edge, so ANY leftward transform clips its leading
   characters - the hint was erasing the content it pointed at. Scrolling cannot clip by
   construction, ends on snap point 0, and needs no done-marker: the observer unobserves,
   and a display toggle cannot replay a scroll the way it restarts a CSS animation. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (!window.matchMedia || !matchMedia('(pointer: coarse)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var rows = document.querySelectorAll('.ij .pgrid, .ij .tiles--4, .ij.guides-section .guides-panes');
  if (!rows.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var r = e.target;
      setTimeout(function () {
        if (r.scrollLeft > 2) return;           /* user already swiped; do not interfere */
        /* Mandatory scroll-snap swallows a programmatic smooth scroll to a non-snap
           position (48 snaps straight back to 0, so nothing visibly moves - measured).
           Snap is suspended for the ~1s peek and restored after; the end position 0 is
           itself a snap point, so nothing jumps on restore. */
        var prevSnap = r.style.scrollSnapType;
        r.style.scrollSnapType = 'none';
        r.scrollTo({ left: 48, behavior: 'smooth' });
        setTimeout(function () { r.scrollTo({ left: 0, behavior: 'smooth' }); }, 480);
        setTimeout(function () { r.style.scrollSnapType = prevSnap; }, 1200);
      }, 300);
    });
  }, { threshold: 0.4 });
  rows.forEach(function (r) { io.observe(r); });
})();


/* PDP gallery autoplay: next image every 4.5s until the user touches the gallery. */
(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var gallery = document.querySelector('product-images');
  if (!gallery) return;
  var stopped = false;
  var visible = false;
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    gallery.addEventListener(ev, function () { stopped = true; }, { passive: true, capture: true });
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { visible = e.isIntersecting; });
    }, { threshold: 0.5 }).observe(gallery);
  } else { visible = true; }
  setInterval(function () {
    if (stopped || !visible || document.hidden) return;
    var next = gallery.querySelector('.slider__button--next');
    if (next && !next.disabled && next.offsetParent) { next.click(); return; }
    var thumb = gallery.querySelector('.product__thumb__link, .product__thumb');
    if (thumb) thumb.click();
  }, 4500);
})();


/* REMOVED 2026-09-07 — client: "HomePage kan je niet toevoegen via snel toevoegen."
 *
 * A deep-link handler used to live here. It matched the SAME `.pcard__size` pills as the
 * real quick-add handler further up this file (search `card quick-add: size pills add the
 * real variant`), and it silently won every time, so the size pills navigated to the PDP
 * instead of adding to the cart. Quick add was therefore dead on every rail sitewide.
 *
 * The reason it always won is worth keeping, because registration order suggests the
 * opposite: it was registered LAST but bound with `useCapture = true`, and the capture
 * phase runs top-down BEFORE the bubble phase reaches the target. It then called
 * `stopPropagation()`, which kills the bubbling listener that does the actual
 * `/cart/add.js` POST. Being later in the file bought it nothing; the third argument did.
 *
 * Deleted rather than reordered: adding to the cart from a pill IS the feature, and the
 * PDP is still one tap away on the card itself. If a deep-link is ever wanted again it
 * must not use capture, and must not stopPropagation.
 */


/* Carousel arrows (Igor 2026-09-06: "all carousels should have arrows on the right
 * bottom so it is also clear it can be swiped. but those should also work of course.")
 *
 * The rails are CSS-only scroll-snap strips, and several of them are a horizontal
 * carousel at one breakpoint and a plain grid at another (.pgrid and .tiles--4 only
 * become flex+overflow inside a mobile media query). So the control cannot be baked
 * into the markup: it is injected here, and ONLY for a rail that genuinely overflows.
 * A rail whose cards already fit its row never grows a button it cannot use, and the
 * same rail grows one the moment the viewport makes it scroll.
 *
 * Step size is measured from the DOM rather than assumed: the distance between the
 * first two laid-out items, which includes whatever gap the rail uses. Items are found
 * by walking THROUGH `display: contents` wrappers, because the guides rail nests its
 * cards inside .favgrid/.guides elements that are themselves contents-only, so the
 * rail's element children have no boxes of their own. Hidden tab panes are skipped for
 * the same reason - they are display:none and must not count toward the step. */
(function () {
  "use strict";

  // OFF since 2026-09-21. Client 09-20: "dan kan die pijl gewoon weg", every rail now
  // shows the next card peeking instead (ij-custom.css .pgrid--rail, .ij-cardrail).
  // The control is kept intact behind this flag; IJ.initRails stays callable and
  // becomes a no-op so the fetch rails and the collection filter keep working.
  var RAIL_ARROWS = false;

  // .ij-cardrail: the Gymshark card strips and sorted product rails (2026-09-16).
  var RAILS = ".pgrid, .tiles--4, .guides-panes, .setsrow, .subtiles, .ij-cardrail";
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="DIR"/></svg>';
  var PREV = ARROW.replace("DIR", "15 5 8 12 15 19");
  var NEXT = ARROW.replace("DIR", "9 5 16 12 9 19");

  function laidOutItems(rail) {
    var out = [];
    (function walk(parent) {
      Array.prototype.forEach.call(parent.children, function (el) {
        var cs = getComputedStyle(el);
        if (cs.display === "none") return;
        // A contents-only wrapper generates no box; its children are the real items.
        if (cs.display === "contents") { walk(el); return; }
        if (el.getBoundingClientRect().width > 0) out.push(el);
      });
    })(rail);
    return out;
  }

  function stepFor(rail) {
    var items = laidOutItems(rail);
    if (items.length > 1) {
      var delta = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      if (delta > 8) return delta;
    }
    if (items.length === 1) return items[0].getBoundingClientRect().width;
    return Math.round(rail.clientWidth * 0.8);
  }

  function build(rail) {
    if (rail.__ijRailNav) return rail.__ijRailNav;
    var nav = document.createElement("div");
    nav.className = "ij-railnav";
    nav.innerHTML =
      '<button type="button" class="ij-railnav__btn" data-ij-dir="-1" aria-label="' + ((window.IJ && IJ.strings && IJ.strings.prev) || "Vorige") + '">' + PREV + "</button>" +
      '<button type="button" class="ij-railnav__btn" data-ij-dir="1" aria-label="' + ((window.IJ && IJ.strings && IJ.strings.next) || "Volgende") + '">' + NEXT + "</button>";
    nav.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest(".ij-railnav__btn") : null;
      if (!btn || btn.disabled) return;
      var dir = Number(btn.getAttribute("data-ij-dir"));
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      rail.scrollBy({ left: dir * stepFor(rail), behavior: reduce ? "auto" : "smooth" });
    });
    rail.insertAdjacentElement("afterend", nav);
    rail.__ijRailNav = nav;
    return nav;
  }

  function sync(rail) {
    if (!RAIL_ARROWS) { if (rail.__ijRailNav) rail.__ijRailNav.hidden = true; return; }
    var overflow = rail.scrollWidth - rail.clientWidth;
    // Sub-pixel layout maths can leave a stray fraction; 2px keeps that from
    // showing a control on a rail that does not actually scroll.
    if (overflow <= 2) {
      if (rail.__ijRailNav) rail.__ijRailNav.hidden = true;
      return;
    }
    var nav = build(rail);
    nav.hidden = false;
    var btns = nav.querySelectorAll(".ij-railnav__btn");
    btns[0].disabled = rail.scrollLeft <= 1;
    btns[1].disabled = rail.scrollLeft >= overflow - 1;
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll(RAILS), sync);
  }

  // Idempotent per rail, because rails now also arrive AFTER load: the sorted
  // product rails are filled by fetch, and the vendor collection filter swaps the
  // whole grid column (rail shell included) on every filter change. Exposed as
  // IJ.initRails(root) for those two callers.
  function bindRail(rail) {
    if (rail.__ijRailBound) { sync(rail); return; }
    rail.__ijRailBound = true;
    sync(rail);
    var queued = false;
    rail.addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(rail); });
    }, { passive: true });
    // Lazy images land after first paint and change scrollWidth.
    rail.addEventListener("load", function () { sync(rail); }, true);
    if ("ResizeObserver" in window) new ResizeObserver(function () { sync(rail); }).observe(rail);
  }

  function initRails(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(RAILS), bindRail);
  }
  window.IJ = window.IJ || {};
  window.IJ.initRails = initRails;

  function init() {
    var rails = document.querySelectorAll(RAILS);
    if (!rails.length) return;
    initRails(document);
    window.addEventListener("resize", syncAll, { passive: true });
    // The guides/collection tabs swap which pane is display:none, which changes the
    // rail's scrollWidth without resizing the rail itself.
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".favtoggle__btn")) requestAnimationFrame(syncAll);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();


/* Collection pages, Gymshark structure (Igor 2026-09-16).
 *
 * [1] Clamped intro. The collection description is cut to three lines by CSS
 *     (.ij-clamp__body) and gets a "Lees meer" toggle ONLY when the text really
 *     overflows, which is measured rather than assumed, so a one-line intro never
 *     grows a pointless button.
 *
 * [2] Sorted product rails. Liquid cannot sort a collection, so the Top 10 and
 *     Nieuw binnen rails are shells with data-ij-fetch pointing at
 *     /collections/<handle>?view=rail&sort_by=... (templates/collection.rail.liquid,
 *     layout none, cards only). The shell is filled here, trimmed to data-ij-limit,
 *     and the whole section is REMOVED when nothing comes back, so a thin collection
 *     never shows an empty heading. The vendor collection filter replaces the grid
 *     column's innerHTML (shell included) on every filter change, so a MutationObserver
 *     re-runs this for shells that arrive later. */
(function () {
  "use strict";

  // [1] clamp
  function initClamps(root) {
    (root || document).querySelectorAll("[data-ij-clamp]").forEach(function (box) {
      if (box.__ijClamp) return;
      box.__ijClamp = true;
      var body = box.querySelector(".ij-clamp__body");
      var btn = box.querySelector("[data-ij-clamp-toggle]");
      if (!body || !btn) return;
      function measure() {
        if (box.classList.contains("ij-is-open")) return;
        // 2px of tolerance for sub-pixel line boxes.
        btn.hidden = body.scrollHeight <= body.clientHeight + 2;
      }
      btn.addEventListener("click", function () {
        var open = box.classList.toggle("ij-is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
      measure();
      window.addEventListener("resize", measure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }

  // [2] fetch rails
  function fillRail(rail) {
    if (rail.__ijFetched) return;
    rail.__ijFetched = true;
    var src = rail.getAttribute("data-ij-fetch");
    var limit = parseInt(rail.getAttribute("data-ij-limit"), 10) || 10;
    var section = rail.closest("[data-ij-rail-section]") || rail;
    if (!src) return;
    fetch(src, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var items = Array.prototype.slice.call(tmp.querySelectorAll(".ij-cardrail__item"), 0, limit);
        if (!items.length) { section.remove(); return; }
        rail.innerHTML = "";
        items.forEach(function (it) { rail.appendChild(it); });
        rail.removeAttribute("aria-busy");
        rail.classList.add("ij-is-filled");
        if (window.IJ && window.IJ.initRails) window.IJ.initRails(section);
        // wishlist hearts on the new cards: the binder in the first IIFE is not
        // exported, so re-dispatch its idempotent bind through a synthetic event.
        document.dispatchEvent(new CustomEvent("ij:cards:added", { detail: { root: rail } }));
      })
      .catch(function () { section.remove(); });
  }
  function initFetchRails(root) {
    (root || document).querySelectorAll("[data-ij-fetch]").forEach(fillRail);
  }

  function init() {
    initClamps(document);
    initFetchRails(document);
    if ("MutationObserver" in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          initFetchRails(document);
          initClamps(document);
          if (window.IJ && window.IJ.initRails) window.IJ.initRails(document);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* Client 2026-09-25: change the size inside the cart. The select sits on each cart line
 * (snippets/cart-line-items.liquid). Shopify cannot swap a line's variant, so add the new
 * variant with the same quantity first, then remove the old line, then let Broadcast
 * re-render its drawer (theme:cart:refresh). The /cart page reloads instead. */
(function () {
  document.addEventListener("change", function (e) {
    var sel = e.target.closest && e.target.closest("[data-ij-cart-size]");
    if (!sel) return;
    var key = sel.getAttribute("data-line-key");
    var qty = parseInt(sel.getAttribute("data-qty"), 10) || 1;
    var id = parseInt(sel.value, 10);
    var line = sel.closest("[data-item]");
    if (line) line.style.opacity = ".5";
    sel.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var json = function (url, body) {
      return fetch(root + url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    };
    json("cart/add.js", { items: [{ id: id, quantity: qty }] })
      .then(function () { return json("cart/change.js", { id: key, quantity: 0 }); })
      .catch(function () {})
      .then(function () {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
      });
  });
})();

/* Igor 2026-09-29: the cart upsell must just work. Broadcast's "Add" opened a second product sheet
 * (card, sheet, size, add), which the Klaviyo popup and the preview bar could cover. Now the sizes open
 * inside the upsell card and one tap adds it (Gymshark's pattern). Capture phase + stopImmediatePropagation
 * so Broadcast's own listener on the button never opens its sheet. Single-variant cards (no modal handle)
 * keep Broadcast's direct add. */
(function () {
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; };
  var sizeIdx = function (p) {
    var names = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); });
    for (var i = 0; i < names.length; i++) if (/^(size|maat|maten)$/.test(names[i])) return i;
    return -1;
  };
  var added = function (holder) {
    var s = (window.IJ && window.IJ.strings) || {};
    holder.classList.add("ij-up-added");
    var box = holder.querySelector(".ij-upsizes");
    if (box) {
      var done = document.createElement("span");
      done.className = "ij-upsizes__done";
      done.textContent = s.added || (document.documentElement.lang === "nl" ? "Toegevoegd" : "Added");
      box.replaceChildren(done);
    }
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
  };
  document.addEventListener("click", function (e) {
    var chip = e.target.closest && e.target.closest("[data-ij-upsize]");
    if (chip) {
      e.preventDefault(); e.stopImmediatePropagation();
      var h = chip.closest("[data-quick-add-holder]");
      chip.disabled = true; chip.classList.add("is-loading");
      fetch(root() + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(chip.getAttribute("data-ij-upsize"), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { added(h); })
        .catch(function () { chip.disabled = false; chip.classList.remove("is-loading"); chip.classList.add("is-error"); });
      return;
    }
    var btn = e.target.closest && e.target.closest(".product-upsell__btn[data-quick-add-modal-handle]");
    if (!btn || !btn.closest(".cart__widget__products")) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var holder = btn.closest("[data-quick-add-holder]");
    var open = holder.querySelector(".ij-upsizes");
    if (open) { open.remove(); holder.classList.remove("ij-up-open"); btn.setAttribute("aria-expanded", "false"); return; }
    var handle = btn.getAttribute("data-quick-add-modal-handle");
    btn.classList.add("is-loading");
    fetch(root() + "products/" + handle + ".js").then(function (r) { return r.json(); }).then(function (p) {
      btn.classList.remove("is-loading");
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (vs.length === 1) {
        var one = document.createElement("div"); one.className = "ij-upsizes"; holder.appendChild(one);
        return fetch(root() + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: vs[0].id, quantity: 1 }] }) }).then(function () { added(holder); });
      }
      var si = sizeIdx(p);
      var box = document.createElement("div");
      box.className = "ij-upsizes";
      vs.forEach(function (v) {
        var chip = document.createElement("button");
        chip.type = "button";
        chip.className = "ij-upsizes__chip";
        chip.setAttribute("data-ij-upsize", String(v.id));
        chip.textContent = si >= 0 ? v.options[si] : v.title;
        box.appendChild(chip);
      });
      holder.appendChild(box);
      holder.classList.add("ij-up-open");
      btn.setAttribute("aria-expanded", "true");
    }).catch(function () { btn.classList.remove("is-loading"); });
  }, true);
})();

/* Igor 2026-09-29 (image audit): on 6 products every size variant carries its own image, and
 * Broadcast jumps the PDP gallery to the variant image on every option change. On the Embrace
 * Hoodie Black that swapped the main photo to a different model when a size was picked. Colours
 * are separate products here, so when a product's only option is size, the gallery never moves.
 * A product with a real second option (colour) keeps Broadcast's behaviour. */
(function () {
  if (!window.customElements) return;
  var sizeOnly = function (el) {
    var legends = el.querySelectorAll("variant-selects fieldset legend");
    if (!legends.length) return false;
    return Array.prototype.every.call(legends, function (l) { return /^(size|maat|maten)\b/i.test(l.textContent.trim()); });
  };
  customElements.whenDefined("product-info").then(function () {
    var C = customElements.get("product-info");
    if (!C || !C.prototype.updateMedia || C.prototype.__ijSizeGuard) return;
    var orig = C.prototype.updateMedia;
    C.prototype.__ijSizeGuard = true;
    C.prototype.updateMedia = function (id) {
      if (sizeOnly(this)) return;
      return orig.call(this, id);
    };
  });
})();

/* [31] Speed pass: hero video fades in over its poster once playing; video bands only load and
 * play when they come near the viewport, and pause when far out of it. */
(function () {
  document.querySelectorAll('video[data-ij-fadein]').forEach(function (v) {
    var on = function () { v.classList.add('is-playing'); };
    if (!v.paused && v.readyState > 2) on(); else v.addEventListener('playing', on, { once: true });
  });
  var vids = document.querySelectorAll('video[data-ij-lazyvideo]');
  if (!vids.length) return;
  if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { v.play().catch(function () {}); } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '300px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();
